import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect, useRef } from 'react';
import '../css/common.css';
import '../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../store/Slices/formSlice';
import useValidation from '../helpers/validation';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

function Australia() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'Australia') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);

    const [cName, setCName] = useState();
    const [acn, setAcn] = useState();
    const [fName, setFName] = useState();
    const [lName, setLName] = useState();
    const [email, setEmail] = useState();
    const [number, setNumber] = useState();
    const [fax, setFax] = useState();

    const [unit, setUnit] = useState();
    const [sNameNum, setSNameNum] = useState();
    const [suburb, setSuburb] = useState();
    const [state, setState] = useState();
    const [postCodeCity, setPostCodeCity] = useState();

    const [serviceProviderName, setServiceProviderName] = useState();

    const [name, setName] = useState();
    const [date, setDate] = useState();
    const [position, setPosition] = useState();

    //-----------------------------------------------fillform-------------------------------------------------//


    const fillForm = (form) => {
        const JSONData = form;
        document.querySelector('#cName').value = JSONData?.country?.account?.name ?? '';
        document.querySelector('#acn').value = JSONData?.country?.account?.acn ?? '';
        document.querySelector('#fName').value = JSONData?.country?.account?.fname ?? '';
        document.querySelector('#lName').value = JSONData?.country?.account?.lname ?? '';
        document.querySelector('#email').value = JSONData?.country?.account?.email ?? '';
        document.querySelector('#number').value = JSONData?.country?.account?.phone ?? '';
        document.querySelector('#fax').value = JSONData?.country?.account?.fax ?? '';
        setCName(JSONData?.country?.account?.name ?? '');
        setAcn(JSONData?.country?.account?.acn ?? '');
        setFName(JSONData?.country?.account?.fname ?? '');
        setLName(JSONData?.country?.account?.lname ?? '');
        setEmail(JSONData?.country?.account?.email ?? '');
        setNumber(JSONData?.country?.account?.phone ?? '');
        setFax(JSONData?.country?.account?.fax ?? '');

        document.querySelector('#unit').value = JSONData?.country?.address?.unit ?? '';
        document.querySelector('#sNameNum').value = JSONData?.country?.address?.street ?? '';
        document.querySelector('#suburb').value = JSONData?.country?.address?.suburb ?? '';
        document.querySelector('#state').value = JSONData?.country?.address?.state ?? '';
        document.querySelector('#postCodeCity').value = JSONData?.country?.address?.post ?? '';
        setUnit(JSONData?.country?.address?.unit ?? '');
        setSNameNum(JSONData?.country?.address?.street ?? '');
        setSuburb(JSONData?.country?.address?.suburb ?? '');
        setState(JSONData?.country?.address?.state ?? '');
        setPostCodeCity(JSONData?.country?.address?.post ?? '');

        document.querySelector('#serviceProviderName').value = JSONData?.country?.current?.name ?? '';
        setServiceProviderName(JSONData?.country?.current?.name ?? '');

        setTableData(JSONData?.country?.portedNumbers?.range ?? []);

        document.querySelector('#name').value = JSONData?.country?.authorisation?.name ?? '';
        document.querySelector('#date').value = JSONData?.country?.authorisation?.date ?? '';
        document.querySelector('#position').value = JSONData?.country?.authorisation?.position ?? '';
        setName(JSONData?.country?.authorisation?.name ?? '');
        setDate(JSONData?.country?.authorisation?.date ?? '');
        setPosition(JSONData?.country?.authorisation?.position ?? '');
    }

    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    //--------------------------------table declaration (DID Range)--------------------------------------//

    const [tableData, setTableData] = useState([{ id: Date.now(), FirstNumber: '', LastNumber: '', AccNum: '', CAT: '' }]);

    const [dropdownOpen, setDropdownOpen] = useState({});

    const dropdownRefs = useRef({});

    useEffect(() => {
        const handleClickOutside = (event) => {
            Object.keys(dropdownRefs.current).forEach((id) => {
                if (
                    dropdownRefs.current[id] &&
                    !dropdownRefs.current[id].contains(event.target)
                ) {
                    setDropdownOpen(prev => ({ ...prev, [id]: false }));
                }
            });
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    //adding a row
    const addRow = () => {
        setTableData([...tableData, { id: Date.now(), FirstNumber: '', LastNumber: '', Bill: '', AccNum: '', CAT: '' }]);
    };

    //removing a row
    const removeRow = (id) => {
        setTableData(tableData.filter(row => row.id !== id));
    };

    // change handler of table
    const handleChange_table = (id, key, value) => {
        const updatedData = tableData.map(row => {
            if (row.id === id) {
                return { ...row, [key]: value };
            }
            return row;
        });
        setTableData(updatedData);
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            // Read headers from row 5 (0-indexed, so index 4)
            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            // Check if headers match
            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            // Read actual data from row 6 onwards
            const dataRows = jsonData.slice(1);

            // Extract relevant data
            const formattedDataRange = dataRows.map((row, index) => ({
                id: index + 1,
                FirstNumber: row[0] ? row[0].toString() : '',
                LastNumber: row[1] ? row[1].toString() : '',
            }));

            setTableData(formattedDataRange);

            // Validate rows
            let hasError = false;
            formattedDataRange.forEach(row => {
                const isStartValid = /^\d+$/.test(row.FirstNumber);
                const isEndValid = /^\d+$/.test(row.LastNumber);

                // condition: last must be >= first
                const isRangeValid = isStartValid && isEndValid && parseInt(row.LastNumber, 10) >= parseInt(row.FirstNumber, 10);

                if (!isStartValid) {
                    toast.error(`Row ${row.id}: First Number must be numeric and not empty.`);
                    hasError = true;
                }

                if (!isEndValid) {
                    toast.error(`Row ${row.id}: Last Number must be numeric and not empty.`);
                    hasError = true;
                }

                if (isStartValid && isEndValid && !isRangeValid) {
                    toast.error(`Row ${row.id}: Last Number must be greater than or equal to First Number.`);
                    hasError = true;
                }

                setValidationStates(prev => ({
                    ...prev,
                    [`start-${row.id}`]: isStartValid,
                    [`end-${row.id}`]: isRangeValid,
                }));
            });

            // if (hasError) {
            //     setUploadedFileName(''); // reset uploaded file name if any error
            // }
        };

        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        setUploadedFileName('');
        fileInputRef.current.value = '';
        setTableData([{ id: Date.now(), FirstNumber: '', LastNumber: '', AccNum: '', CAT: '' }]);
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "Australia",
            "account": {
                "name": cName,
                "acn": acn,
                "fname": fName,
                "lname": lName,
                "email": email,
                "phone": number,
                "fax": fax
            },

            "address": {
                "unit": unit,
                "street": sNameNum,
                "suburb": suburb,
                "state": state,
                "post": postCodeCity
            },

            "current": {
                "name": serviceProviderName
            },

            "portedNumbers": {
                "range": tableData
            },

            "authorisation": {
                "name": name,
                "date": date,
                "position": position
            }
        },
        "email": sessionStorage.getItem('email')
    };

    const jsonString = JSON.stringify(json);

    //console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {
        e.preventDefault();

        let validationErrors = {};

        if (!cName) {
            validationErrors.cName = 'please fill in the customer name';
        }
        if (!acn) {
            validationErrors.acn = 'please fill in the ACN/ARBN';
        }
        if (!fName) {
            validationErrors.fName = 'please fill in the first name';
        }
        if (!lName) {
            validationErrors.lName = 'please fill in the last name';
        }
        if (!email) {
            validationErrors.email = 'please fill in the email';
        }
        if (!number) {
            validationErrors.number = 'please fill in the phone number';
        }
        if (!unit) {
            validationErrors.unit = 'please fill in the unit';
        }
        if (!sNameNum) {
            validationErrors.sNameNum = 'please fill in the street name and number';
        }
        if (!suburb) {
            validationErrors.suburb = 'please fill in the suburb';
        }
        if (!state) {
            validationErrors.state = 'please fill in the state';
        }
        if (!postCodeCity) {
            validationErrors.postCodeCity = 'please fill in the post code and city';
        }
        if (!serviceProviderName) {
            validationErrors.serviceProviderName = 'please fill in the current service provider name';
        }
        tableData.forEach((row, index) => {
            if (!row.FirstNumber) {
                validationErrors[`start-${row.id}`] = `please fill in the first number in range for row ${index + 1}`;
            }
            if (!row.LastNumber) {
                validationErrors[`end-${row.id}`] = `please fill in the last number in range for row ${index + 1}`;
            }
            if (!row.AccNum) {
                validationErrors[`accNum-${row.id}`] = `please fill in the customer account number for row ${index + 1}`;
            }
            if (!row.CAT) {
                validationErrors[`cat-${row.id}`] = `please fill in the CAT A or CAT C for row ${index + 1}`;
            }
        });
        if (!name) {
            validationErrors.name = 'please fill in the customer name';
        }
        if (!date) {
            validationErrors.date = 'please fill in the date';
        }
        if (!position) {
            validationErrors.position = 'please fill in the position';
        }

        const hasValidationError = Object.keys(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            // Show the first error message
            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];
            document.getElementById(firstErrorKey).scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(firstError);
            return;
        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys} `);
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            return;
        }

        // Show the modal instead of generating the LOA directly
        setIsModalVisible(true);

    }

    async function handleConfirm() {
        setIsModalVisible(false);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: jsonString
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');
            a.href = url;
            a.download = cName + '-LOA.docx';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file: ', error);
            //toast.error("An error occurred while processing your request.");
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home'
        }
    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//

    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <Container>
                    {isModalVisible && (
                        <div className="modal">
                            <div className="modal-content">
                                <h3 style={{ textAlign: 'center' }}>Terms and Conditions</h3>
                                <div className="modal-body">
                                    <ul>
                                        <li>The Porting Authority form is valid for 90 days from date of signing.</li>
                                        <li>Existing service must not be deactivated when porting. Telephone numbers can only be ported while active.</li>
                                        <li>Authority to port this telephone number can only be withdrawn before scheduled port date.</li>
                                        <li>
                                            The gaining service provider cannot provide a guarantee that it can port your telephone number from your
                                            current service provider. Your current service provider may reject this port request if the information you
                                            provide is incorrect or does not match the data held by them. In this case you authorise the gaining service
                                            provider to correct the information and resubmit the request to port your telephone number or dispute the
                                            rejection by your current service provider. A porting request may also be rejected for other reasons as stated
                                            in your local porting code.
                                        </li>
                                        <li>
                                            The gaining service provider cannot provide a guarantee that the telephone number will be ported within any
                                            specified timeframe. Porting hours of operation in Australia are 8am to 5pm AEST/AEDST Monday to Friday,
                                            excluding National Public Holidays.
                                        </li>
                                        <li>In the event of a port, withdrawal or reversal, the gaining service provider is not responsible for any period of outage.</li>
                                        <li>You may have outstanding contractual obligations and costs owed to your current service provider. You are responsible for settling your final account with your service provider.</li>
                                        <li>The gaining service provider is not liable for any such costs.</li>
                                        <li>
                                            Only your telephone number will be transferred to the gaining service provider. This may result in the loss of
                                            any Value Added Services that are associated with the service provided by your existing service provider (e.g. Voicemail).
                                        </li>
                                        <li>If you wish to port your telephone number to another service provider, then you must contact the other provider.</li>
                                        <li>The gaining service provider reserves the right to charge a fee for porting your telephone number to or from itself.</li>
                                        <li>Local Number Portability (LNP) does not guarantee you can keep your telephone number if you move to a different geographic location.</li>
                                    </ul>
                                </div>
                                <label className="checkbox-label">
                                    <input
                                        type="checkbox"
                                        checked={isCheckboxChecked}
                                        onChange={(e) => setIsCheckboxChecked(e.target.checked)}
                                    />
                                    I agree to the terms and conditions
                                </label>
                                <div className="modal-actions">
                                    <button className="cancel-btn" onClick={() => setIsModalVisible(false)}>
                                        Cancel
                                    </button>
                                    <button
                                        className="confirm-btn"
                                        onClick={handleConfirm}
                                        disabled={!isCheckboxChecked}
                                    >
                                        Confirm
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </Container>

                <p><strong>Mandatory fields are marked by *</strong></p>

                <Container>

                    <h2 className='heading'>Customer Account Holder</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('cName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Customer Name*</label> <br />
                            <input
                                onChange={(e) => setCName(e.target.value)}
                                type="text"
                                id="cName"
                                placeholder=""
                                className={`inputbox ${validationStates.cName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('cName', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'cName' && (
                                <div className="hover-description">
                                    Enter the Customer Name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('acn')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>ACN/ARBN (business only)*</label> <br />
                            <input
                                onChange={(e) => setAcn(e.target.value)}
                                type="text"
                                id="acn"
                                placeholder=""
                                className={`inputbox ${validationStates.acn === false ? 'error' : ''}`}
                                onBlur={() => validateInput('acn', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'acn' && (
                                <div className="hover-description">
                                    Australian Registered Body Number (ARBN) is a unique number issued by ASIC to entities registering with them but not as companies. Foreign companies registering with ASIC are assigned an ARBN instead of an ACN. Entities with an ARBN can also apply for an ABN
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('fName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>First Name*</label> <br />
                            <input
                                onChange={(e) => setFName(e.target.value)}
                                type="text"
                                id="fName"
                                placeholder=""
                                className={`inputbox ${validationStates.fName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('fName', /^[a-zA-Z\s]+$/)}

                            />
                            {hoveredField === 'fName' && (
                                <div className="hover-description">
                                    Enter the First Name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('lName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Last Name*</label> <br />
                            <input
                                onChange={(e) => setLName(e.target.value)}
                                type="text"
                                id="lName"
                                placeholder=""
                                className={`inputbox ${validationStates.lName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('lName', /^[a-zA-Z\s]+$/)}

                            />
                            {hoveredField === 'lName' && (
                                <div className="hover-description">
                                    Enter the Last Name
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('email')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Email*</label> <br />
                            <input
                                onChange={(e) => setEmail(e.target.value)}
                                type="text"
                                id="email"
                                placeholder=""
                                className={`inputbox ${validationStates.email === false ? 'error' : ''}`}
                                onBlur={() => validateInput('email', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'email' && (
                                <div className="hover-description">
                                    Enter your Email
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('number')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Phone Number*</label> <br />
                            <input
                                onChange={(e) => setNumber(e.target.value)}
                                type="text"
                                id="number"
                                placeholder=""
                                className={`inputbox ${validationStates.number === false ? 'error' : ''}`}
                                onBlur={() => validateInput('number', /^\+?[1-9]\d{0,14}$/)}

                            />
                            {hoveredField === 'number' && (
                                <div className="hover-description">
                                    Enter the Phone Number
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('fax')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Fax Number</label> <br />
                            <input
                                onChange={(e) => setFax(e.target.value)}
                                type="text"
                                id="fax"
                                placeholder=""
                                className={`inputbox ${validationStates.fax === false ? 'error' : ''}`}
                                onBlur={(e) => {
                                    if (e.target.value.trim() === '') {
                                        setValidationStates(prev => ({ ...prev, fax: true })); // clear error if empty
                                    } else {
                                        validateInput('fax', /^[0-9]+$/);
                                    }
                                }}
                            />
                            {hoveredField === 'fax' && (
                                <div className="hover-description">
                                    Enter the Fax Number
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br />

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Customer Service Address</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('unit')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Unit*</label> <br />
                            <input
                                onChange={(e) => setUnit(e.target.value)}
                                type="text"
                                id="unit"
                                placeholder=""
                                className={`inputbox ${validationStates.unit === false ? 'error' : ''}`}
                                onBlur={() => validateInput('unit', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'unit' && (
                                <div className="hover-description">
                                    Enter your Unit
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('sNameNum')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Street Name and Street Number*</label> <br />
                            <input
                                onChange={(e) => setSNameNum(e.target.value)}
                                type="text"
                                id="sNameNum"
                                placeholder=""
                                className={`inputbox ${validationStates.sNameNum === false ? 'error' : ''}`}
                                onBlur={() => validateInput('sNameNum', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'sNameNum' && (
                                <div className="hover-description">
                                    Enter the Street Name and Number
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('suburb')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Suburb*</label> <br />
                            <input
                                onChange={(e) => setSuburb(e.target.value)}
                                type="text"
                                id="suburb"
                                placeholder=""
                                className={`inputbox ${validationStates.suburb === false ? 'error' : ''}`}
                                onBlur={() => validateInput('suburb', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'suburb' && (
                                <div className="hover-description">
                                    Enter Suburb Name
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('state')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>State*</label> <br />
                            <input
                                onChange={(e) => setState(e.target.value)}
                                type="text"
                                id="state"
                                placeholder=""
                                className={`inputbox ${validationStates.state === false ? 'error' : ''}`}
                                onBlur={() => validateInput('state', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'state' && (
                                <div className="hover-description">
                                    Enter the state name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('postCodeCity')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Post Code and City*</label> <br />
                            <input
                                onChange={(e) => setPostCodeCity(e.target.value)}
                                type="text"
                                id="postCodeCity"
                                placeholder=""
                                className={`inputbox ${validationStates.postCodeCity === false ? 'error' : ''}`}
                                onBlur={() => validateInput('postCodeCity', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'postCodeCity' && (
                                <div className="hover-description">
                                    Enter the Post Code and City
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br />

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Current Service Provider</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('serviceProviderName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Current Service Provider Name*</label> <br />
                            <input
                                onChange={(e) => setServiceProviderName(e.target.value)}
                                type="text"
                                id="serviceProviderName"
                                placeholder=""
                                className={`inputbox ${validationStates.serviceProviderName === false ? 'error' : ''}`}
                                onBlur={() => validateInput('serviceProviderName', /^[\w\W,]+$/)}

                            />
                            {hoveredField === 'serviceProviderName' && (
                                <div className="hover-description">
                                    Enter the current service provider name
                                </div>
                            )}
                        </Col>

                        <Col></Col>

                    </Row>

                    <br />

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Numbers to be ported</h2> <br></br>

                    <p>I wish to port the following services to the gaining service provider</p>

                    <Row>
                        <Col>
                            <button
                                variant="secondary"
                                className="inputbox"
                                style={{ alignItems: 'center' }}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                Upload File
                            </button>
                            <input
                                id="fileUploadInput"
                                type="file"
                                accept=".xlsx, .xls"
                                onChange={handleFileUpload}
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                            />
                        </Col>

                        <Col>
                            <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                Download number range template
                            </button>
                        </Col>

                        <Col>
                            {uploadedFileName && (
                                <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                    Remove
                                </button>
                            )}
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            {uploadedFileName && (
                                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                    <p style={{ marginRight: '10px' }}>Uploaded File: {uploadedFileName}</p>
                                </div>
                            )}
                        </Col>
                    </Row>

                    <br />
                    <p>The template is the same used for the btd portability request.</p>
                    <br />

                    <Table striped bordered hover variant="light">
                        <thead>
                            <tr>
                                <th>First number in range*</th>
                                <th>Last number in range*</th>
                                <th>Customer Account Number*</th>
                                <th>CAT A or CAT C(*) <br /> (A single number / C range of numbers)*</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map(row => (
                                <tr key={row.id}>
                                    {/* First Number */}
                                    <td>
                                        <input
                                            type="text"
                                            id={`start-${row.id}`}
                                            value={row.FirstNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_table(row.id, 'FirstNumber', value);

                                                const isValid = /^\d+$/.test(value);
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`start-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`start-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                const isValid = /^\d+$/.test(row.FirstNumber);
                                                if (!isValid) {
                                                    toast.error('First Number must be numeric and cannot be empty.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`start-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {validationStates[`start-${row.id}`] === false && (
                                            <div className="error-message">First Number must be numeric and cannot be empty.</div>
                                        )}
                                    </td>

                                    {/* Last Number */}
                                    <td>
                                        <input
                                            type="text"
                                            id={`end-${row.id}`}
                                            value={row.LastNumber}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_table(row.id, 'LastNumber', value);

                                                const isValid =
                                                    /^\d+$/.test(value) &&
                                                    row.FirstNumber &&
                                                    /^\d+$/.test(row.FirstNumber) &&
                                                    parseInt(value, 10) >= parseInt(row.FirstNumber, 10);

                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`end-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`end-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                const isValid =
                                                    /^\d+$/.test(row.LastNumber) &&
                                                    row.FirstNumber &&
                                                    /^\d+$/.test(row.FirstNumber) &&
                                                    parseInt(row.LastNumber, 10) >= parseInt(row.FirstNumber, 10);

                                                if (!isValid) {
                                                    let msg = 'Last Number must be numeric and cannot be empty.';
                                                    if (
                                                        /^\d+$/.test(row.LastNumber) &&
                                                        /^\d+$/.test(row.FirstNumber) &&
                                                        parseInt(row.LastNumber, 10) < parseInt(row.FirstNumber, 10)
                                                    ) {
                                                        msg = 'Last Number must be greater than or equal to First Number.';
                                                    }
                                                    toast.error(msg);
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`end-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {validationStates[`end-${row.id}`] === false && (
                                            <div className="error-message">
                                                {row.FirstNumber && /^\d+$/.test(row.FirstNumber) &&
                                                    row.LastNumber && /^\d+$/.test(row.LastNumber) &&
                                                    parseInt(row.LastNumber, 10) < parseInt(row.FirstNumber, 10)
                                                    ? 'Last Number must be greater than or equal to First Number.'
                                                    : 'Last Number must be numeric and cannot be empty.'}
                                            </div>
                                        )}
                                    </td>

                                    {/* Account Number */}
                                    <td>
                                        <input
                                            type="text"
                                            id={`accNum-${row.id}`}
                                            value={row.AccNum}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                handleChange_table(row.id, 'AccNum', value);

                                                const isValid = value.trim() !== '';
                                                setValidationStates(prev => ({
                                                    ...prev,
                                                    [`accNum-${row.id}`]: isValid,
                                                }));
                                            }}
                                            className={`inputbox ${validationStates[`accNum-${row.id}`] === false ? 'error' : ''}`}
                                            onBlur={() => {
                                                const isValid = row.AccNum.trim() !== '';
                                                if (!isValid) {
                                                    toast.error('Account Number cannot be empty.');
                                                    setValidationStates(prev => ({
                                                        ...prev,
                                                        [`accNum-${row.id}`]: false,
                                                    }));
                                                }
                                            }}
                                        />
                                        {validationStates[`accNum-${row.id}`] === false && (
                                            <div className="error-message">Account Number cannot be empty.</div>
                                        )}
                                    </td>

                                    {/* CAT Dropdown */}
                                    <td style={{ position: 'relative' }} ref={el => (dropdownRefs.current[row.id] = el)}>
                                        <div
                                            className={`inputbox ${validationStates[`cat-${row.id}`] === false ? 'error' : ''}`}
                                            onClick={() =>
                                                setDropdownOpen(prev => ({ ...prev, [row.id]: !prev[row.id] }))
                                            }
                                            style={{
                                                cursor: 'pointer',
                                                whiteSpace: 'normal',
                                                wordWrap: 'break-word',
                                                backgroundColor: '#fff',
                                                height: '26px'
                                            }}
                                        >
                                            {row.CAT || 'Select'}
                                        </div>

                                        {dropdownOpen[row.id] && (
                                            <ul
                                                style={{
                                                    position: 'absolute',
                                                    top: '100%',
                                                    left: 0,
                                                    width: '100%',
                                                    maxHeight: '150px',
                                                    overflowY: 'auto',
                                                    border: '1px solid #ccc',
                                                    backgroundColor: '#fff',
                                                    zIndex: 1000,
                                                    padding: 0,
                                                    margin: 0,
                                                    listStyle: 'none',
                                                }}
                                            >
                                                <li
                                                    style={{
                                                        padding: '5px',
                                                        whiteSpace: 'normal',
                                                        cursor: 'pointer',
                                                        borderBottom: '1px solid #eee',
                                                    }}
                                                    onClick={() => {
                                                        handleChange_table(row.id, 'CAT', 'CAT A');
                                                        setValidationStates(prev => ({ ...prev, [`cat-${row.id}`]: true }));
                                                        setDropdownOpen(prev => ({ ...prev, [row.id]: false }));
                                                    }}
                                                >
                                                    Simple or ‘CAT A’ Ports = Single / Individual Number ports
                                                </li>
                                                <li
                                                    style={{
                                                        padding: '5px',
                                                        whiteSpace: 'normal',
                                                        cursor: 'pointer',
                                                    }}
                                                    onClick={() => {
                                                        handleChange_table(row.id, 'CAT', 'CAT C');
                                                        setValidationStates(prev => ({ ...prev, [`cat-${row.id}`]: true }));
                                                        setDropdownOpen(prev => ({ ...prev, [row.id]: false }));
                                                    }}
                                                >
                                                    Complex or ‘CAT C’ Ports = Typically 2 or more consecutive numbers, number blocks, and/or numbers with complex services attached to.
                                                </li>
                                            </ul>
                                        )}

                                        {validationStates[`cat-${row.id}`] === false && (
                                            <div className="error-message">Please select a category (CAT A or CAT C).</div>
                                        )}
                                    </td>

                                    {/* Remove Button */}
                                    <td>
                                        {tableData.length > 1 && (
                                            <button onClick={() => removeRow(row.id)}>Remove</button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    <button onClick={addRow}>Add Row</button>

                </Container>

                <br></br><br></br>

                <Container>

                    <h2 className='heading'>Customer Authorisation</h2> <br></br>

                    <p>•	I designate Orange Business Services Australia Pty ltd, 357 Collins Street (Level 13), 3000 Melbourne, Australia, to act as my agent in changing the gaining service provider.
                    </p>
                    <p>•	I accept the Terms & Conditions listed above and authorise for the telephone number(s) listed in this form to be ported to the gaining service provider.
                    </p>
                    <p>•	I acknowledge that I am authorised to request the porting of the telephone number(s) listed on this form.
                    </p>
                    <p>•	I indemnify the gaining service provider against any loss or damage it may suffer as a result of any information included in this form.
                    </p>
                    <p>•	I also authorise the gaining service provider to obtain from the current service provider any incomplete or further details, which are required to facilitate the port of the numbers listed in this form.
                    </p>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('name')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Name*</label> <br />
                            <input
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                id='name'
                                placeholder=""
                                className={`inputbox ${validationStates.name === false ? 'error' : ''}`}
                                onBlur={() => validateInput('name', /^[a-zA-Z\s]+$/)}
                            />
                            {hoveredField === 'name' && (
                                <div className="hover-description">
                                    Enter your name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('position')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Position*</label> <br />
                            <input
                                onChange={(e) => setPosition(e.target.value)}
                                type="text"
                                id='position'
                                placeholder=""
                                className={`inputbox ${validationStates.position === false ? 'error' : ''}`}
                                onBlur={() => validateInput('position', /^[a-zA-Z0-9\s,]+$/)}
                            />
                            {hoveredField === 'position' && (
                                <div className="hover-description">
                                    Enter your Position
                                </div>
                            )}
                        </Col>

                        <Col>
                            <label>Date*</label> <br></br>
                            <input
                                onChange={(e) => setDate(e.target.value)}
                                type="date"
                                id='date'
                                placeholder=""
                                className={`inputbox ${validationStates.date === false ? 'error' : ''}`}
                                onBlur={() => validateInput('date', /^.*$/)}
                            />
                        </Col>

                    </Row>

                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="save" onClick={save}>Save</Button>
                    <Button variant="primary" type="submit" onClick={Submit}>Generate LOA</Button>
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>

            </div>

        </div>
    );
}

export default Australia;